const getInitialsFromText = (text = "") => {
  if (typeof text !== "string" || !text) return "";

  const words = text.trim().split(/[\s_-]+/).filter(Boolean);

  if (words.length === 0) return "";

  if (words.length === 1) {
    const word = words[0];
    if (word === word.toUpperCase() && word.length > 1) {
      return (word[0] + word[word.length - 1]).toUpperCase();
    }
    return word.slice(0, 2).toUpperCase();
  }

  const firstInitial = words[0][0];
  const lastInitial = words[words.length - 1][0];

  return (firstInitial + lastInitial).toUpperCase();
};

export default getInitialsFromText;
